import { Outlet, useOutletContext } from 'react-router-dom'

import { ApprovalsGroupFragment } from 'generated/resources/graphql'

import ApprovalGroupEmployeesTable from 'modules/approvals/components/Employees/ApprovalGroupEmployeesTable'

const EmployeesPage = () => {
  const { group } = useOutletContext<{ group: ApprovalsGroupFragment }>()

  return (
    <>
      <ApprovalGroupEmployeesTable approvalGroup={group} />
      <Outlet context={{ group }} />
    </>
  )
}

export default EmployeesPage
